import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';

export default function useIsOpenSearch(): boolean {
  const { appliedFilters } = useContext(AppliedFiltersContext);

  return Object.keys(appliedFilters).length === 0;
}
